export default async function(context) {
  // keep track of the current page in order to provide "history" information when choosing the correct transition
  context.store.commit('setPage', context.route.name)
  const accountDetails = await context.store.dispatch(
    'account/getAccountDetails'
  )
  context.store.dispatch('account/setAccountDetails', accountDetails)
}
